
import {
    postClevertapDeleteProfile, postLearnUserDeleteProfile,
} from "../repositories/registration/register";
import {
    getMessagingSearchRepo,
    getMessagingContentRepo,
    postMessagingContentRepo,
    putMessagingContentRepo,
    deleteMessagingContentRepo,
} from "../repositories/registration/messaging";
import { getGoogleFlowDomainListRepo, postGoogleFlowRepo, } from "../repositories/registration/googleFlow"
import { getUserAccountsRepo, postDeleteUserAccountRepo, postLogoutUserAccountRepo, } from "../repositories/registration/accountDeletion"
import { createSlice } from "@reduxjs/toolkit";

const registerSlice = createSlice({
    name: "registerReducer",
    initialState: {

        messagingContentLoading: false,
        messagingContent: null,
        messagingContentError: null,

        msgContUrlMetaLoading: false,
        msgContUrlMeta: null,
        msgContUrlMetaError: null,

        messagingSearchLoading: false,
        messagingSearch: null,
        messagingSearchError: null,

        postMessagingContentLoading: false,
        postMessagingContentData: null,
        postMessagingContentError: null,

        putMessagingContentLoading: false,
        putMessagingContentData: null,
        putMessagingContentError: null,

        deleteMessagingContentLoading: false,
        deleteMessagingContentData: null,
        deleteMessagingContentError: null,
        message:null,

        userAccountsLoading: false,
        userAccounts: null,
        userAccountsError: null,

        postDeleteUserAccountLoading: false,
        postDeleteUserAccount: null,
        postDeleteUserAccountError: null,

        postLogoutUserAccountLoading: false,
        postLogoutUserAccount: null,
        postLogoutUserAccountError: null,

        clevertapDeleteProfileLoading: false,
        clevertapDeleteProfileSuccess: null,
        clevertapDeleteProfileFailure: null,

        learnUserLogoutSuccess: null,
        learnUserLogoutFailure: null,

        googleFlowDomainListloading: false,
        googleFlowDomainListData: null,
        googleFlowDomainListError: null,

        postGoogleFlowLoading: false,
        postGoogleFlowData: null,
        postGoogleFlowError: null,

        
    },
    reducers: {
        

        getMessagingContentLoading(state, action) {
            return {
                ...state,
                messagingContentLoading: true,
            };
        },
        getMessagingContentSuccess(state, action) {
            return {
                ...state,
                messagingContentLoading: false,
                messagingContent: action.payload,
            };
        },
        getMessagingContentFailure(state, action) {
            return {
                ...state,
                messagingContentLoading: false,
                messagingContentError: action.payload,
            };
        },

        getMsgContUrlMetaLoading(state, action) {
            return {
                ...state,
                msgContUrlMetaLoading: true,
            };
        },
        getMsgContUrlMetaSuccess(state, action) {
            return {
                ...state,
                msgContUrlMetaLoading: false,
                msgContUrlMeta: action.payload,
            };
        },
        getMsgContUrlMetaFailure(state, action) {
            return {
                ...state,
                msgContUrlMetaLoading: false,
                msgContUrlMetaError: action.payload,
            };
        },

        getMessagingSearchLoading(state, action) {
            return {
                ...state,
                messagingSearchLoading: true,
            };
        },
        getMessagingSearchSuccess(state, action) {
            return {
                ...state,
                messagingSearchLoading: false,
                messagingSearch: action.payload,
            };
        },
        getMessagingSearchFailure(state, action) {
            return {
                ...state,
                messagingSearchLoading: false,
                messagingSearchError: action.payload,
            };
        },

        postMessagingContentLoading(state, action) {
            return {
                ...state,
                messagingContentLoading: true,
                message:null
            };
        },
        postMessagingContentSuccess(state, action) {
            return {
                ...state,
                messagingContentLoading: false,
                postMessagingContentData: action.payload,
                message:action.payload,
            };
        },
        postMessagingContentFailure(state, action) {
            return {
                ...state,
                messagingContentLoading: false,
                postMessagingContentError: action.payload,
                message:action.payload,
            };
        },
        postMessagingContentClear(state, action) {
            return {
                ...state,
                postMessagingContentData: null,
                postMessagingContentError:null,
            };
        },

        putMessagingContentLoading(state, action) {
            return {
                ...state,
                putMessagingContentLoading: true,
                message:null
            };
        },
        putMessagingContentSuccess(state, action) {
            return {
                ...state,
                putMessagingContentLoading: false,
                putMessagingContentData: action.payload,
                message:action.payload,
            };
        },
        putMessagingContentFailure(state, action) {
            return {
                ...state,
                putMessagingContentLoading: false,
                putMessagingContentError: action.payload,
                message: action.payload,
            };
        },
        putMessagingContentlear(state, action) {
            return {
                ...state,
                putMessagingContentData: null,
                putMessagingContentError: null,
            };
        },

        deleteMessagingContentLoading(state, action) {
            return {
                ...state,
                deleteMessagingContentLoading: true,
                message: null
            };
        },
        deleteMessagingContentSuccess(state, action) {
            return {
                ...state,
                deleteMessagingContentLoading: false,
                deleteMessagingContentData: action.payload,
            };
        },
        deleteMessagingContentFailure(state, action) {
            return {
                ...state,
                deleteMessagingContentLoading: false,
                deleteMessagingContentError: action.payload,
            };
        },
        getUserAccountsLoading(state, action) {
            return {
                ...state,
                userAccountsLoading: true,
            }
        },
        getUserAccountsSuccess(state, action) {
            return {
                ...state,
                userAccountsLoading: false,
                userAccounts: action.payload,
            }
        },
        getUserAccountsFailure(state, action) {
            return {
                ...state,
                userAccountsLoading: false,
                userAccountsError: action.payload,
            }
        },

        postDeleteUserAccountLoading(state, action) {
            return {
                ...state,
                postDeleteUserAccountLoading: true,
                message: "Account deletion is in process Please do not refresh the page",
            }
        },
        postDeleteUserAccountSuccess(state, action) {
            return {
                ...state,
                postDeleteUserAccountLoading: false,
                postDeleteUserAccount: action.payload,
                message: "User Account Deleted Successfully",
            }
        },
        postDeleteUserAccountFailure(state, action) {
            return {
                ...state,
                postDeleteUserAccountLoading: false,
                postDeleteUserAccountError: action.payload,
                message: "Failure in Deleting account",
            }
        },
        clearPostDeleteUserAccount(state, action) {
            return {
                ...state,
                postDeleteUserAccountLoading: false,
                postDeleteUserAccount: null,
                postDeleteUserAccountError: null,
                message: null,
            }
        },
        postLogoutUserAccountLoading(state, action) {
            return {
                ...state,
                postLogoutUserAccountLoading: true,
            }
        },
        postLogoutUserAccountSuccess(state, action) {
            return {
                ...state,
                postLogoutUserAccountLoading: false,
                postLogoutUserAccount:  action.payload,
            }
        },
        postLogoutUserAccountFailure(state, action) {
            return {
                ...state,
                postLogoutUserAccountLoading: false,
                postLogoutUserAccountFailure:  action.payload,
            }
        },

        postClevertapDeleteProfileLoading(state, action) {
            return {
                ...state,
                clevertapDeleteProfileLoading: true,
            }
        },
        postClevertapDeleteProfileSuccess(state, action) {
            return {
                ...state,
                clevertapDeleteProfileLoading: false,
                clevertapDeleteProfileSuccess: action.payload,
            }
        },
        postClevertapDeleteProfileFailure(state, action) {
            return {
                ...state,
                clevertapDeleteProfileLoading: false,
                clevertapDeleteProfileFailure: action.payload,
            }
        },
        postLearnUserLogoutSuccess(state, action) {
            return {
                ...state,
                learnUserLogoutSuccess: action.payload,
            }
        },
        postLearnUserLogoutFailure(state, action) {
            return {
                ...state,
                learnUserLogoutFailure: action.payload,
            }
        },
        getGoogleFlowDomainListLoading(state, action) {
            return {
                ...state,
                googleFlowDomainListloading: true,
            };
        },
        getGoogleFlowDomainListSuccess(state, action) {
            return {
                ...state,
                googleFlowDomainListloading: false,
                googleFlowDomainListData: action.payload,
            };
        },
        getGoogleFlowDomainListFailure(state, action) {
            return {
                ...state,
                googleFlowDomainListloading: false,
                googleFlowDomainListError: action.payload,
            };
        },
        postGoogleFlowLoading(state, action) {
            return {
                ...state,
                postGoogleFlowLoading: true,
            };
        },
        postGoogleFlowSuccess(state, action) {
            return {
                ...state,
                postGoogleFlowLoading: false,
                postGoogleFlowData: action.payload,
                message:"Google preferences updated successfully.",
            };
        },
        postGoogleFlowFailure(state, action) {
            return {
                ...state,
                postGoogleFlowLoading: false,
                postGoogleFlowError: action.payload,
                message:"Something Went Wrong",
            };
        },
        clearMessage(state,action){
            return{
                ...state,
                message:null,
                postMessagingContentError:null,
                putMessagingContentError:null,
                deleteDegreeGroupingError:null,
                userAccounts: null,
                userAccountsError: null,
                postDeleteUserAccount: null,
                postDeleteUserAccountError: null,
                postGoogleFlowData:null,
                postGoogleFlowError:null,
            }
        }
    },
});
export const {

    getMessagingContentLoading,
    getMessagingContentSuccess,
    getMessagingContentFailure,

    getMsgContUrlMetaLoading,
    getMsgContUrlMetaSuccess,
    getMsgContUrlMetaFailure,

    getMessagingSearchLoading,
    getMessagingSearchSuccess,
    getMessagingSearchFailure,

    postMessagingContentLoading,
    postMessagingContentSuccess,
    postMessagingContentFailure,
    postMessagingContentClear,

    putMessagingContentLoading,
    putMessagingContentSuccess,
    putMessagingContentFailure,

    deleteMessagingContentLoading,
    deleteMessagingContentSuccess,
    deleteMessagingContentFailure,

    getUserAccountsLoading,
    getUserAccountsSuccess,
    getUserAccountsFailure,

    postDeleteUserAccountLoading,
    postDeleteUserAccountSuccess,
    postDeleteUserAccountFailure,

    postLogoutUserAccountLoading,
    postLogoutUserAccountSuccess,
    postLogoutUserAccountFailure,

    postClevertapDeleteProfileLoading,
    postClevertapDeleteProfileSuccess,
    postClevertapDeleteProfileFailure,

    postLearnUserLogoutSuccess,
    postLearnUserLogoutFailure,

    getGoogleFlowDomainListLoading,
    getGoogleFlowDomainListSuccess,
    getGoogleFlowDomainListFailure,

    postGoogleFlowLoading,
    postGoogleFlowSuccess,
    postGoogleFlowFailure,


    clearMessage

} = registerSlice.actions;

export const getMessagingContent = (params) => {
    return async (dispatch) => {
        dispatch(getMessagingContentLoading());
        await getMessagingContentRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getMessagingContentSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getMessagingContentFailure(error.message));
                }
            });
    };
};

export const getMsgContUrlMetaPatternType = (params) => {
    return async (dispatch) => {
        dispatch(getMsgContUrlMetaLoading());
        await getMessagingContentRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getMsgContUrlMetaSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getMsgContUrlMetaFailure(error.message));
                }
            });
    };
};

export const getMessagingSearch = (params) => {
    return async (dispatch) => {
        dispatch(getMessagingSearchLoading());
        await getMessagingSearchRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getMessagingSearchSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getMessagingSearchFailure(error.message));
                }
            });
    };
};

export const postMessagingContent = (params) => {
    return async (dispatch) => {
        dispatch(postMessagingContentLoading());
        await postMessagingContentRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 302
                ) {
                    dispatch(postMessagingContentSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postMessagingContentFailure(error.message));
                }
            });
    };
};

export const putMessagingContent = (data) => {
    return async (dispatch) => {
        dispatch(putMessagingContentLoading());
        await postMessagingContentRepo(data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(putMessagingContentSuccess(response?.data?.data));

                } else {
                    dispatch({
                        payload: response && response.message,
                    });
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putMessagingContentFailure(error.response?.data));
                }
            });
    };
};

export const deleteMessagingContent = (id,data) => {
    return (dispatch) => {
        deleteMessagingContentRepo(id,data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(deleteMessagingContentSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deleteMessagingContentFailure(error.message));
                }
            });
    };
};

export const getAllUserAccounts = (params) => {
    return async (dispatch) => {
        dispatch(getUserAccountsLoading())
        await getUserAccountsRepo(params)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(getUserAccountsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getUserAccountsFailure(error.message));
                }
            });
    };
};

export const deleteUserAccount = (id,data) => {
    return async (dispatch) => {
        dispatch(postDeleteUserAccountLoading())
        await postDeleteUserAccountRepo(id,data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(postDeleteUserAccountSuccess(response?.data?.data));
                    dispatch(clevertapDeleteProfle({guid: id?.user_id}))
                    dispatch(logoutUserAccount({user_id: id?.user_id}))
                    dispatch(learnUserLogout({learn_user_id: id?.learn_id}))
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postDeleteUserAccountFailure(error.message));
                }
            });
    };
};

export const logoutUserAccount = (data) => {
    return async (dispatch) => {
        dispatch(postLogoutUserAccountLoading())
        await postLogoutUserAccountRepo(data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(postLogoutUserAccountSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postLogoutUserAccountFailure(error.message));
                }
            });
    };
};

export const clevertapDeleteProfle = (data) => {
    return async (dispatch) => {
        dispatch(postClevertapDeleteProfileLoading());
        await postClevertapDeleteProfile(data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(postClevertapDeleteProfileSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postClevertapDeleteProfileFailure(error.message));
                }
            })
    }
}

export const learnUserLogout = (data) => {
    return async (dispatch) => {
        await postLearnUserDeleteProfile(data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(postLearnUserLogoutSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postLearnUserLogoutFailure(error.message));
                }
            })
    }
}

// Google Flow Domain List action
export const getGoogleFlowDimainList = (params) => {
    return async (dispatch) => {
        dispatch(getGoogleFlowDomainListLoading());
        await getGoogleFlowDomainListRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getGoogleFlowDomainListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getGoogleFlowDomainListFailure(error.message));
                }
            });
    };
};

// Google Flow action
export const postGoogleFlow = (data) => {
    return async (dispatch) => {
        dispatch(postGoogleFlowLoading());
        await postGoogleFlowRepo(data)
            .then((response) => {
                if ( response?.status >= 200 && response?.status <= 300 ) {
                    dispatch(postGoogleFlowSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postGoogleFlowFailure(error.message));
                }
            });
    };
};



export default registerSlice.reducer;
